// extracted by mini-css-extract-plugin
export var divider = "_g9-7";
export var itemsToggle = "_g9-8";
export var mergeModal = "_g9-1";
export var optionCard = "_g9-4";
export var radioGroup = "_g9-6";
export var radioOption = "_g9-0";
export var selected = "_g9-5";
export var shipmentOptions = "_g9-2";
export var tableOptions = "_g9-3";